import Checkbox from '@gameday/react-components/components/Checkbox'
import styled from 'styled-components'

import ToolTip from '../../../components/form/Common/ToolTip'
import styles from '../../styles.module.scss'

const StyledCheckboxContainer = styled.div`
  .MuiCheckbox-colorPrimary.Mui-checked,
  .MuiIconButton-colorPrimary {
    color: var(--custom-primary-color);
  }
`

function Component({
  onChange = () => {},
  onBlur = () => {},
  errorText,
  label,
  value,
  isMandatory,
  helpText,
  name,
  id,
  dataTestId,
}) {
  return (
    <StyledCheckboxContainer className={styles.checkboxContainer}>
      <Checkbox
        onBlur={onBlur}
        isChecked={!!value}
        isRequired={isMandatory}
        onChecked={value => onChange(value)}
        style={{ marginTop: -5 }}
        label={label}
        name={name}
        id={`${id}-checkbox`}
        inputProps={{
          'data-testid': dataTestId,
        }}
      />
      {helpText && <ToolTip text={helpText} />}
      {errorText && <div className={styles.customErrorText}>{errorText}</div>}
    </StyledCheckboxContainer>
  )
}

export default Component
